import type { AxiosInstance } from 'axios'
import URI from 'urijs'

export const getCompanyList = (api: AxiosInstance) => (
  page = 1,
  limit: number,
  q: string,
  sortBy: string,
  sortDirection: string,
  ...args: any[]
) =>
  api.get(
    '/v1.0/admin/companies?' +
      URI.buildQuery({
        page,
        limit,
        keyword: q,
        sortBy,
        sortDirection
      }),
    ...args
  )
